/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReportStatusEnum {
    SCHEDULED = 'scheduled',
    PROCESSING = 'processing',
    ERROR = 'error',
    COMPLETED = 'completed',
    UPLOADED = 'uploaded',
}
